(ns bec-cljs-common.config
  (:require [lambdaisland.uri :refer [uri]]
            [cljs.reader]
            [clojure.string :as s]))


(defonce device-id (or (-> (.getItem js/window.localStorage "bec-cljs-common.config/device-id")
                           (cljs.reader/read-string))
                       (let [new-id (random-uuid)]
                         (.setItem js/window.localStorage "bec-cljs-common.config/device-id" (pr-str new-id))
                         new-id)))


(defonce session-id (or (-> (.getItem js/window.sessionStorage "bec-cljs-common.config/session-id")
                            (cljs.reader/read-string))
                        (let [new-id (random-uuid)]
                          (.setItem js/window.sessionStorage "bec-cljs-common.config/session-id" (pr-str new-id))
                          new-id)))


(defonce viewport-id (random-uuid))


;; These are set! by bcc.core/init! - which must be called as early as possible in the app.
(declare app-server-url)
(declare app-type)
(declare app-category)
(declare stream-name) ;; E.g. given to `stream-name` arg of bcc.net/sse-url.
(declare client-state-path) ;; E.g. given to `client-state-path` arg of bcc.net/start-sse.


(defn path [& args] (vec (concat client-state-path args))) ;; TODO: Not really config, but..
